// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Aw9I","label":"styles_label__1n0y4"};